import React, { useState, useRef, useEffect, useContext } from "react";
import { Grid, Image, Input } from 'semantic-ui-react'
import moment from "moment";
import OwlCarousel from 'react-owl-carousel';
import searchicon from "../assets/home/searchicon.svg";
import timeicon from "../assets/home/timeicon.svg";
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from "react-router-dom";
import { Config } from "../common"
import { ongoingContestSlider, ContestList } from "../store/TriviaRedux"
import StarButton from './StarButton'
import Loading from './Loading'
import { useTranslation } from "react-i18next";
import NoOrderHistory from "./NoOrderHistory";
import Countdown from 'react-countdown';
import InfiniteScroll from 'react-infinite-scroll-component';

const OnGoing = ({ isSearch, isSlider }) => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch()
  const history = useHistory();
  const token = useSelector((state) => state.auth.token)
  const ongoings = useSelector((state) => state.trivia.ongoingContest)
  const contests = useSelector((state) => state.trivia.contests)
  const isFetching = useSelector((state) => state.trivia.isFetching)
  const [search, setSearch] = useState('')
  const [page, setPage] = useState(1)
  const timer = useRef();
  const [sliders, setSliders] = useState([])

  useEffect(() => {
    if (isSlider) {
      dispatch(ongoingContestSlider({ token }))
    } else {
      dispatch(ContestList({ status: 'ongoing', pageNo: 1, pageSize: 10, token }))
    }
  }, []);

  const handleSearch = (value) => {
    setSearch(value)
    let param = { status: 'ongoing', pageNo: 1, pageSize: 10, token }
    if (value) {
      param.title = value
    }
    clearInterval(timer.current);
    timer.current = setTimeout(() => {
      dispatch(ContestList(param))
    }, 500)
  }

  const fetchData = () => {
    if (contests.loadMore) {
      setPage(page + 1)
      let param = { status: 'ongoing', pageNo: page, pageSize: 10, token }
      if (search) {
        param.title = search
      }
      dispatch(ContestList(param))
    }
  }

  const refreshData = () => {

  }

  useEffect(() => {
    setSliders(JSON.parse(JSON.stringify(ongoings)))
  }, [i18n.language && ongoings]);


  const renderer = ({ days, hours, minutes, seconds }) => {
    return <div className="contestTime">
      <img src={timeicon} /> <span>Contest ends in : {days}d {hours}h {minutes}m</span>
    </div>
  };

  return (
    <>
      {isSearch && (<div className="conten">
        <div className="input_box clearall">
          <div className="search_sec">
            <img className="searchicon" src={searchicon} />
            <Input value={search} onChange={(e) => handleSearch(e.target.value)} placeholder='Search' />
          </div>
        </div>
      </div>)}

      {isFetching && (<Loading />)}

      {isSlider ? <>{sliders.length > 0 ? <OwlCarousel className='owl-theme' items={1} nav>
        {sliders.map((item, key) => {
          let basicDetails = Config.GetLanguage(item?.contest, i18n.language, 'basicDetails')
          let newDate = moment.utc(item?.contest?.endDate) - moment.utc(Config.localUtc())
          return <div key={key} className="harshita" style={{ background: `url(${item?.contest?.image}) no-repeat`, backgroundSize: 'cover', }}>
            <Grid className="contestBg" verticalAlign='middle'>
              <Grid.Column computer={4} mobile={6} tablet={4}>
                <Image src={item?.contest?.mobileImage} />
              </Grid.Column>
              <Grid.Column computer={7} mobile={10} tablet={8}>
                <h3>{basicDetails?.title}</h3>
                <div className="shot_border"></div>
                <div className="prizes">
                  <i className="fa fa-info-circle" aria-hidden="true"></i>
                  <span>{`Entry fee: ₹ ${item?.contest?.entryFee}`}</span>
                </div>
              </Grid.Column>
              <Grid.Column computer={4} mobile={16} tablet={4}>
                <div className="onGoingButton">
                  <Countdown date={Date.now() + newDate} renderer={renderer} />
                  <StarButton background={'mainBg smallButWidth'} title={t("contest.btn")} onClickAction={() => history.push(`/landing/${item?.contest?._id}`)} disableStar={true} />
                </div>
              </Grid.Column>
            </Grid>
          </div>
        })}
      </OwlCarousel> : null}</> : <div>
        {contests?.data?.length > 0 ?
          <InfiniteScroll
            dataLength={contests?.data?.length} //This is important field to render the next data
            next={fetchData}
            hasMore={true}
            loader={<h4>Loading...</h4>}
            endMessage={
              <p style={{ textAlign: 'center' }}>
                <b>Yay! You have seen it all</b>
              </p>
            }
            // below props only if you need pull down functionality
            refreshFunction={refreshData}
            pullDownToRefresh
            pullDownToRefreshThreshold={50}
            pullDownToRefreshContent={
              <h3 style={{ textAlign: 'center' }}>&#8595; Pull down to refresh</h3>
            }
            releaseToRefreshContent={
              <h3 style={{ textAlign: 'center' }}>&#8593; Release to refresh</h3>
            }
          >
            {contests.data.map((item, key) => {
              let basicDetails = Config.GetLanguage(item, i18n.language, 'basicDetails')
              let newDate = moment.utc(item?.endDate) - moment.utc(Config.localUtc())
              return <div key={key} className="harshita" style={{ background: `url(${item?.image}) no-repeat`, backgroundSize: 'cover', }}>
                <Grid className="contestBg" verticalAlign='middle'>
                  <Grid.Column computer={4} mobile={6} tablet={4}>
                    <Image src={item?.mobileImage} />
                  </Grid.Column>
                  <Grid.Column computer={7} mobile={10} tablet={7}>
                    <h3>{basicDetails.title}</h3>
                    <div className="shot_border"></div>
                    <div className="prizes">
                      <i className="fa fa-info-circle" aria-hidden="true"></i>
                      <span>{`Entry fee: ₹ ${item?.entryFee}`}</span>
                    </div>
                  </Grid.Column>
                  <Grid.Column computer={4} mobile={16} tablet={4}>
                    <div className="onGoingButton">
                    <Countdown date={Date.now() + newDate} renderer={renderer} />
                      {/* <StarButton background={'mainBg'} title={t("contest.btn")} onClickAction={() => history.push(`/landing/${item?._id}`)} disableStar={true} /> */}

                      <button
                        onClick={() => history.push(`/landing/${item?._id}`)} className='click' >

                        {t("contest.btn")}


                      </button>
                    </div>
                  </Grid.Column>
                </Grid>
              </div>
            })}
          </InfiniteScroll> : <NoOrderHistory />}
      </div>}
    </>
  );
};



export default OnGoing;
